export const routes = {
    adminCompanies: "/admin/companies",
    adminCompanyDetail: "/admin/companies/:id",
    adminInvitations: "/admin/invitations",
    adminSendInvite: "/admin/send-invite",
    code: "/code",
    forgotPassword: "/forgot-password",
    login: "/login",
    profile: "/profile",
    register: "/register",
    resetPassword: "/reset-password",
    result: "/result",
    root: "/",
} as const;

export const buildAdminCompanyDetailRouteHandler = (companyId: number | string): string => `/admin/companies/${companyId}`;
